import styled from 'styled-components';

export const AdressItem = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0px 0px 8px #80808024;
  background: #ffffff;
  border-radius: 7px;
  margin-bottom: 10px;
  padding: 15px 10px 15px 0px;
  border: 1px solid
    ${(props) => (props.border ? props.theme.colors.blue : '#ffffff')};
  @media (max-width: 991px) {
    margin-top: 20px;
    padding: 15px 10px 15px 10px;
  }
`;

export const AdressLineContainer = styled.div``;

export const AdressLine = styled.div`
  font-size: 14px;
  color: ${(props) =>
    props.color ? props.theme.colors.blue : '#4D565C'};
  text-overflow: ellipsis;
  width: 374px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  @media (max-width: 991px) {
    font-size: 0.9375rem;
    width: 100%;
    text-overflow: initial;
    white-space: break-spaces;
  }
`;

export const AdressName = styled.span`
  font-size: 1.125rem;
  color: #4d565c;
  @media (max-width: 991px) {
    font-size: 1rem;
  }
`;

export const AdressIcon = styled.span`
  font-size: 1.5625rem;
  color: #f0b01b;
  margin-right: 5px;
  @media (max-width: 991px) {
    font-size: 1.25rem;
  }
`;

export const AdressNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > div {
    font-weight: bold;
  }
`;

export const Select = styled.input`
  background: #0011FF;
  margin-right: 30px;
  margin-left: 20px;
  @media (max-width: 991px) {
    margin-right: 20px;
    margin-left: 5px;
  }
`;

export const AdressInfoContainer = styled.div``;

export const Hr = styled.hr`
  width: 100%;
  height: 0.5px;
  color: #808495;
  margin-top: 20px;
`;

export const AdressTitleIcon = styled.span`
  font-size: 1.4375rem;
  color: #ffffff;
  margin-bottom: -20px;
  margin-right: 15px;
`;

export const AddressContainer = styled.div`
  height: 610px;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    height: 480px;
  }
`;

export const AddressItemContainer = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  ::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  ::-webkit-scrollbar {
    width: 3px;
    background: rgba(0, 0, 0, 0.071);
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.4);
  }
  overflow-x: hidden;
  flex: 1;
  max-width: 100%;
  width: 485px;
  padding-right: 30px;
`;

export const AddressButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  max-width: 100%;
  width: 465px;
  @media (max-width: 1850px) {
    margin-top: 0;
  }
`;

export const Title = styled.span`
  font-size: 1.125rem;
  color: #074f8c;
  padding-bottom: 1.875rem;
`;

export const FormHeader = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    position: absolute;
    top: -171px;
  }

  h2 {
    font-size: 1.4375rem;
    color: ${({ theme }) => theme.colors.blue};
    font-weight: 500;
    margin-bottom: 12px;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 1.125rem;
      color: rgba(255, 255, 255, 0.9);
      font-weight: bold;
      margin-left: -5px;
      margin-right: -5px;

      br {
        display: none;
      }
    }
  }

  h3 {
    font-size: 0.9375rem;
    color: #7a7a7a;
    max-width: 350px;
    margin-bottom: 18px;
    @media (max-width: 768px) {
      color: #c9dfff;
      font-size: 0.8125rem;
      margin-left: -5px;
      margin-right: -5px;
    }
  }
`;
